import {
    Box,
    Button,
    CircularProgress,
    makeStyles,
    MenuItem,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core"
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab"
import QRCode from "qrcode"
import { useEffect, useState } from "react"
import QrCodeIcon from "../../assets/QrCodeIcon.png"
import RepresentanteSelector from "../../functions/RepresentanteSelector"
import api from "../../services/api"
import useAppStore from "../../stores/AppStore"
import { useSnackbar } from "../../utils/notificacoes"
import Cabecalho from "../Cabecalho"
import { gerarArteQrCode } from "./gerarArteQrCode"

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing(4, 2),
        backgroundColor: "#f5f5f5",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        padding: theme.spacing(4),
        borderRadius: theme.spacing(1),
        boxShadow: theme.shadows[3],
        width: "80%",
        maxWidth: 900,
        gap: theme.spacing(3),
        height: "fit-content",
        [theme.breakpoints.down("sm")]: {
            width: "95%",
        },
    },
    linhaCampos: {
        display: "flex",
        gap: theme.spacing(2),
        flexWrap: "wrap",
        alignItems: "flex-start",
    },
    linhaBotoes: {
        display: "flex",
        gap: theme.spacing(2),
        flexWrap: "wrap",
    },
    campoMesa: {
        flex: "1 1 160px",
    },
    campoEstabelecimento: {
        flex: "1 1 220px",
    },
    qrGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
        gap: theme.spacing(2),
        maxHeight: 480,
        overflowY: "auto",
        padding: theme.spacing(1),
    },
    qrCard: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(1.5),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        backgroundColor: "#fafafa",
    },
    qrImagem: {
        width: 110,
        height: 110,
        marginBottom: theme.spacing(1),
    },
    placeholder: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(4),
        border: `1px dashed ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
    },
}))

const LIMITE_MESAS = 200

export default function PedidoDeMesaQrCode() {
    const classes = useStyles()
    const { enqueueSnackbar } = useSnackbar()
    const configuracoes = useAppStore(s => s.configuracoes)
    const autorizacao = localStorage.getItem("chaveSistema")

    const [modoVariasMesas, setModoVariasMesas] = useState(false)
    const [mesaInicial, setMesaInicial] = useState("1")
    const [mesaFinal, setMesaFinal] = useState("1")
    const [estabelecimentos, setEstabelecimentos] = useState([])
    const [estabelecimentoId, setEstabelecimentoId] = useState(
        configuracoes?.user?.parametros?.estabelecimento?.id || ""
    )
    const [previews, setPreviews] = useState([])
    const [gerando, setGerando] = useState(false)
    const [modoArte, setModoArte] = useState(false)
    const [wifiNome, setWifiNome] = useState("")
    const [wifiSenha, setWifiSenha] = useState("")

    useEffect(() => {
        const buscarEstabelecimentos = async () => {
            try {
                const resp = await api.get("integracao/buscarestabelecimentos", {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                const lista = Array.isArray(resp.data) ? resp.data : []
                const atual = configuracoes?.user?.parametros?.estabelecimento
                const listaCompleta =
                    atual?.id && !lista.some(e => e.id === atual.id)
                        ? [{ id: atual.id, nome: atual.nome }, ...lista]
                        : lista
                setEstabelecimentos(listaCompleta)
            } catch (error) {}
        }
        buscarEstabelecimentos()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const montarLinkMesa = mesa =>
        `https://${configuracoes.user.parametros.urlSiteAplicativo}/login/?mesa=${mesa}&loja=${estabelecimentoId}&pedidoMesa=true`

    const handleAtivarVariasMesas = () => {
        setMesaFinal(mesaInicial)
        setModoVariasMesas(true)
    }

    const handleVoltarMesaUnica = () => {
        setModoVariasMesas(false)
    }

    const handleGerar = async () => {
        const inicio = parseInt(mesaInicial, 10)
        const fim = modoVariasMesas ? parseInt(mesaFinal, 10) : inicio

        if (!inicio || !fim || inicio < 1 || fim < inicio) {
            enqueueSnackbar("Informe um número de mesa válido.", { variant: "warning" })
            return
        }
        if (fim - inicio + 1 > LIMITE_MESAS) {
            enqueueSnackbar(`Gere no máximo ${LIMITE_MESAS} mesas por vez.`, { variant: "warning" })
            return
        }
        if (!estabelecimentoId) {
            enqueueSnackbar("Selecione um estabelecimento.", { variant: "warning" })
            return
        }

        setGerando(true)
        try {
            const gerados = []
            for (let mesa = inicio; mesa <= fim; mesa++) {
                const url = await QRCode.toDataURL(montarLinkMesa(mesa), { width: 400, margin: 1 })
                gerados.push({ mesa, url })
            }
            setPreviews(gerados)

            if (modoArte) {
                const estabelecimentoAtual = configuracoes?.user?.parametros?.estabelecimento
                const estabelecimentoSelecionado = estabelecimentos.find(
                    e => String(e.id) === String(estabelecimentoId)
                )
                const nomeEstabelecimento =
                    estabelecimentoSelecionado?.nome || estabelecimentoAtual?.nome || ""
                const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF") || "null")
                const urlLogoClienteFiel = RepresentanteSelector.getRepresentante().isClienteFiel()
                    ? aplicativoDados?.urlLogo
                    : ""

                for (const { mesa, url } of gerados) {
                    const arteUrl = await gerarArteQrCode({
                        mesa,
                        qrDataUrl: url,
                        nomeEstabelecimento,
                        urlLogoClienteFiel,
                        wifiNome,
                        wifiSenha,
                    })
                    const link = document.createElement("a")
                    link.href = arteUrl
                    link.download = `mesa ${mesa} - cardapio digital.png`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }
            } else {
                gerados.forEach(({ mesa, url }) => {
                    const link = document.createElement("a")
                    link.href = url
                    link.download = `mesa ${mesa}.png`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                })
            }

            enqueueSnackbar(
                `${gerados.length} ${modoArte ? "arte(s)" : "QR code(s)"} gerado(s) e baixado(s) com sucesso.`,
                { variant: "success" }
            )
        } catch (error) {
            enqueueSnackbar(
                `Houve um erro ao gerar ${modoArte ? "a(s) arte(s)" : "os QR codes"}.`,
                { variant: "error" }
            )
        }
        setGerando(false)
    }

    return (
        <div className={classes.root}>
            <Cabecalho pagina={"QR Code de Mesas"} />
            <Paper className={classes.container}>
                <Typography variant="h6">Gerar QR Codes de mesas</Typography>

                <div className={classes.linhaCampos}>
                    <TextField
                        className={classes.campoMesa}
                        label={modoVariasMesas ? "Mesa inicial" : "Mesa"}
                        type="number"
                        variant="outlined"
                        value={mesaInicial}
                        onChange={e => setMesaInicial(e.target.value)}
                        inputProps={{ min: 1 }}
                    />
                    {modoVariasMesas ? (
                        <TextField
                            className={classes.campoMesa}
                            label="Mesa final"
                            type="number"
                            variant="outlined"
                            value={mesaFinal}
                            onChange={e => setMesaFinal(e.target.value)}
                            inputProps={{ min: 1 }}
                        />
                    ) : null}
                    {estabelecimentos.length > 1 ? (
                        <TextField
                            className={classes.campoEstabelecimento}
                            select
                            label="Estabelecimento"
                            variant="outlined"
                            value={estabelecimentoId}
                            onChange={e => setEstabelecimentoId(e.target.value)}
                        >
                            {estabelecimentos.map(estabelecimento => (
                                <MenuItem key={estabelecimento.id} value={estabelecimento.id}>
                                    {estabelecimento.nome}
                                </MenuItem>
                            ))}
                        </TextField>
                    ) : null}
                </div>

                <Box>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        O que deseja baixar?
                    </Typography>
                    <ToggleButtonGroup
                        exclusive
                        value={modoArte ? "arte" : "simples"}
                        onChange={(e, valor) => {
                            if (valor !== null) setModoArte(valor === "arte")
                        }}
                    >
                        <ToggleButton value="simples" disabled={gerando}>
                            Apenas QR Code
                        </ToggleButton>
                        <ToggleButton value="arte" disabled={gerando}>
                            Arte para impressão
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>

                {modoArte ? (
                    <div className={classes.linhaCampos}>
                        <TextField
                            className={classes.campoEstabelecimento}
                            label="Nome da rede Wi-Fi (opcional)"
                            variant="outlined"
                            value={wifiNome}
                            onChange={e => setWifiNome(e.target.value)}
                            helperText="Aparece na arte, se preenchido"
                        />
                        <TextField
                            className={classes.campoEstabelecimento}
                            label="Senha do Wi-Fi (opcional)"
                            variant="outlined"
                            value={wifiSenha}
                            onChange={e => setWifiSenha(e.target.value)}
                        />
                    </div>
                ) : null}

                <Box className={classes.linhaBotoes}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleGerar}
                        disabled={gerando}
                        startIcon={gerando ? <CircularProgress size={18} color="inherit" /> : null}
                    >
                        {gerando
                            ? "Gerando..."
                            : modoVariasMesas
                            ? `Gerar e baixar ${modoArte ? "artes" : "QR Codes"}`
                            : `Gerar e baixar ${modoArte ? "arte" : "QR Code"}`}
                    </Button>
                    {!modoVariasMesas ? (
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleAtivarVariasMesas}
                            disabled={gerando}
                        >
                            {`Gerar e baixar vários ${modoArte ? "artes" : "QR Codes"}`}
                        </Button>
                    ) : (
                        <Button
                            variant="outlined"
                            onClick={handleVoltarMesaUnica}
                            disabled={gerando}
                        >
                            Voltar para mesa única
                        </Button>
                    )}
                </Box>

                {previews.length > 0 ? (
                    <div className={classes.qrGrid}>
                        {previews.map(({ mesa, url }) => (
                            <div key={mesa} className={classes.qrCard}>
                                <img
                                    className={classes.qrImagem}
                                    src={url}
                                    alt={`QR Code mesa ${mesa}`}
                                />
                                <Typography variant="body2">Mesa {mesa}</Typography>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={classes.placeholder}>
                        <img
                            src={QrCodeIcon}
                            alt="QR Code"
                            style={{ width: 80, height: 80, marginBottom: 8 }}
                        />
                        <Typography variant="body2" color="textSecondary">
                            Informe o intervalo de mesas e clique em gerar
                        </Typography>
                    </div>
                )}
            </Paper>
        </div>
    )
}
